import * as React from 'react'
import { withRouter } from 'next/router'
import type { SearchPagePropsType } from '../../models/Search'
import { getSearchTagPropsAsync } from '../../models/Search'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import SearchPage from '@components/Search/SearchPage'
function Search (props: SearchPagePropsType): React.ReactNode {
  return (
    <DiscoverLayout title={'Search all audiobooks on Dipsea'}>
      <SearchPage {...props}/>
    </DiscoverLayout>
  )
}
export default withRouter(Search as any) as any

export async function getStaticProps (): Promise<{ props: SearchPagePropsType }> {
  const searchRecs = await getSearchTagPropsAsync()
  return { props: searchRecs }
}
